import { all } from '@redux-saga/core/effects';

function* frequencyRevisionWatcher() {
  yield all([]);
}

export default frequencyRevisionWatcher;
